import $ from 'jquery';
import Glide from '@glidejs/glide';

export default function CarouselViewModel() {
    const cycleSpeedMs = $('#ImageRotateSpeed').val() * 1000;
    let carousel = $('.glide');
    let showThumbnail = document.getElementById('ShowThumbnails');

    if (showThumbnail) {
        this.animationDuration = 1000;
    } else {
        this.animationDuration = 2000;
    }


    if (carousel.length) {
        new Glide(carousel.get(0),
            {
                type: 'carousel',
                autoplay: cycleSpeedMs,
                swipeThreshold: false,
                dragThreshold: false,
                breakpoints: {
                    800: {
                        perView: 1
                    }
                },
                animationDuration: this.animationDuration
            }).mount();
    };

    $(window).on('load', () => {
        $('.carousel__caption').each((index, caption) => {

            let image = $(caption).prev('.carousel__image');
            if (image.length)
            {
                $(caption).width(image.get(0).width);
            }
        });
    });

    return this;
}